// @ts-nocheck
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


//CRAIG add errorState Later?
const initialState = {
  details: null,
  climateData: null,
  loadingClimateData: "idle",
  yrRainMax: null,
  loadingYrRainMax: "idle",
};

// export const fetchClimateData = createAsyncThunk(
//     'station/fetchClimateData',
//     async (ClimateID, thunkAPI) => {
//       try{
//         const { data } = await API.graphql(graphqlOperation(listGeoPoints));
//         return data.listGeoPoints.items;
//       }
//       catch (error) {
//         return thunkAPI.rejectWithValue(error.message);
//       }
//     }
//   )


const SelectedStationSlice = createSlice({
  name: "selectedStation",
  initialState,
  reducers: {
    setSelectStation: (state, action) => {
      state.details = action.payload;
    },
    setClimateData: (state, action) => {
      state.climateData = action.payload;
    },
  },
});

export const { setSelectStation } = SelectedStationSlice.actions;
export default SelectedStationSlice.reducer;
